<div class="disabled-overlay" *ngIf="processing">
  <div>
    <div class="spinner" [app-center-in-container]>
      <div class="lspinner"></div>
    </div>
  </div>
</div>

<div class="container-fluid user-logged-in">
  <div #genericFloatingAlert style="white-space: pre-line;" class="alert floating mt-2" [ngClass]="alertClass" role="alert" *ngIf="alert">
    <i class="alert-close" (click)="alert=null" aria-hidden="true"></i>
    {{ alert.message }}
  </div>
</div>
<div class="keyboard-container">
  <div class="simple-keyboard"></div>
</div>
<div>
  <main>
    <div>
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
